import { render, staticRenderFns } from "./CDescriptionItem.vue?vue&type=template&id=a0bb3e54"
import script from "./CDescriptionItem.vue?vue&type=script&lang=js"
export * from "./CDescriptionItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports